module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/chevron_quote-0902c9597796cd251d8c6c24ab16316e.svg";